import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import heroImage from '../assets/493665-PHGW0X-4 1.png';
import roadmapimage from '../assets/Frame 3@512p-25fps.gif';
import imgPersonalityTypes from '../assets/IMAGE (3).png';
import imgColorfulInsights from '../assets/IMAGE (4).png';
import imgGrowthTracking from '../assets/IMAGE (5).png';
import imgPrivacyFirst from '../assets/IMAGE (6).png';
import framePersonalityTypes from '../assets/Frame.png';
import frameColorfulInsights from '../assets/Frame (1).png';
import frameGrowthTracking from '../assets/Frame (2).png';
import framePrivacyFirst from '../assets/Frame (3).png';
import frame1 from '../assets/person frame 1.png';
import frame2 from '../assets/person frame 2.png';
import frame3 from '../assets/person frame 3.png';
import frame4 from '../assets/person frame  4.png';
import frame5 from '../assets/person frame 5.png';
import frame6 from '../assets/person frame 6.png';
import frame7 from '../assets/person frame 7.png';
import frame8 from '../assets/person frame 8.png';
import heartFrame from '../assets/heart frame.png';
import lovely1 from '../assets/lovely 1.png';
import lovely from '../assets/lovely.png';
import heartLogo from '../assets/heart logo.png';
import routingIcon from '../assets/routing.png';
import mapImage from '../assets/Map.png';
import ArrowImg from '../assets/Arrow.png';
import starFrame from '../assets/star frame.png';
import brainFrame from '../assets/Brain frame.png';
import rectangleShape from '../assets/rectangle shape.png';
import triangle from '../assets/triangle.png';
import testimonial1 from '../assets/testimonial 1.png';
import testimonial2 from '../assets/testimonial 2.png';
import testimonial3 from '../assets/testimonial 3.png';
import testimonialStarFrame from '../assets/testimonial star frame.png';
import questionMark from '../assets/question mark.png';
import msgFrame from '../assets/msg frame.png';
import phoneFrame from '../assets/phone frame.png';
import locationFrame from '../assets/location frame.png';
import peopleFrame from '../assets/people frame.png';
import bookFrame from '../assets/book frame.png';
import facebookFrame from '../assets/facebook frame.png';
import twitterFrame from '../assets/twitter frame.png';
import instagramFrame from '../assets/instagram frame.png';
import linkedinFrame from '../assets/linkedin frame.png';
import youtubeFrame from '../assets/youtube frame.png';
import downArrowFrame from '../assets/down arrow frame.png';
import blueHearts from '../assets/blue hearts.png';
import wire from '../assets/wire.png';
import Navbar from '../components/NavbarLanding';
import twoPeople from '../assets/two people.png';
import Footer from './Footer';
import hworkIcon from '../assets/hwork_icon.png';
import photoroom from '../assets/photo 1.png';
import messageQuestionIcon from '../assets/message-question.png';
// use existing down chevron for FAQ toggle
import spotify from '../assets/sound.png';
import likeTag from '../assets/like-tag.png';
import quoteDown from '../assets/quote-down.png';
import ratingIcon from '../assets/ranking.png';
import flowerIcon from '../assets/flower.png';
import spotifyLogo from '../assets/spotify.png';
import puzzleIcon from '../assets/puzzle.png';
import competencyRanking from '../assets/competency ranking.png';
import sparklesStars from '../assets/sparkles stars.png';
import bigfiveIcon from '../assets/bigfive.png';
import chartPie from '../assets/chart-pie.png';
import talentHand from '../assets/talent-hand.png';
import operationIcon from '../assets/operation.png';
import healingIcon from '../assets/healing.png';
import graduationCap from '../assets/graduation-cap.png';
import objectsImg from '../assets/objects.png';
import group1Img from '../assets/group 1.png';
import moreFlowersImg from '../assets/more-flowers.png';
import insightImg from '../assets/insight.png';
import privateImg from '../assets/private.png';

const stats = [
  { label: '1M+', desc: 'Tests Taken' },
  { label: '13', desc: 'Personality Types' },
  { label: '98%', desc: 'Accuracy Rate' },
  { label: '150+', desc: 'Countries' },
];

const features = [
  { title: '13 Personality Types', desc: 'Discover your unique type and get a comprehensive report.', icon: '🧠' },
  { title: 'Colorful Insights', desc: 'Each personality type has its own color palette and insights.', icon: '🎨' },
  { title: 'Growth Tracking', desc: 'Monitor your personal development journey with actionable feedback.', icon: '📈' },
  { title: 'Privacy First', desc: 'Your data is secure and never shared without your consent.', icon: '🔒' },
];

const tests = [
  { title: 'Essence Echo', desc: 'A reflection of your inner voice today', color: 'bg-pink-100', frame: frame1, iconBg: 'bg-[#FFB8B3]' },
  { title: 'IKIGAI Finder', desc: 'Where passion, skill, and meaning align ', color: 'bg-purple-100', frame: frame2, iconBg: 'bg-[#CE93D8]' },
  { title: 'Johari Window Builder', desc: 'What you know, and what others see', color: 'bg-green-100', frame: frame3, iconBg: 'bg-[#A5D6A7]' },
  { title: 'High 5 Strengths', desc: 'The talents that carry you forward', color: 'bg-blue-100', frame: frame4, iconBg: 'bg-[#90CAF9]' },
  { title: 'Competencies Test', desc: 'Skills that support your goals', color: 'bg-yellow-100', frame: frame5, iconBg: 'bg-[#FFCC80]' },
  { title: 'Character Strengths', desc: 'Virtues that shape how you lead', color: 'bg-pink-100', frame: frame6, iconBg: 'bg-[#F8BBD9]' },
  { title: 'Big Five', desc: 'The five traits that shape you ', color: 'bg-green-100', frame: frame7, iconBg: 'bg-[#C5E1A5]' },
  { title: 'DISC Assessment', desc: 'How you communicate and collaborate.', color: 'bg-purple-100', frame: frame8, iconBg: 'bg-[#B39DDB]' },
  { title: 'Enneagram Finder', desc: 'Core motivations and growth paths', color: 'bg-blue-100', frame: frame1, iconBg: 'bg-white' },
  { title: 'TypeFusion Finder', desc: 'The lens through which you process life', color: 'bg-green-100', frame: frame2, iconBg: 'bg-white' },
  { title: 'Emotional IQ', desc: 'How you absorb and apply knowledge', color: 'bg-yellow-100', frame: frame3, iconBg: 'bg-white' },
  { title: 'Learning Style', desc: 'How you absorb and apply new ideas', color: 'bg-pink-100', frame: frame4, iconBg: 'bg-white' },
];

const testimonials = [
  { name: 'Sarah Johnson', role: 'Marketing Manager', badge: 'The Harmonizer', badgeColor: 'bg-[#FF5722]', text: 'This test gave me so much clarity about myself!', img: testimonial1, color: 'bg-orange-100' },
  { name: 'Michael Chen', role: 'Software Developer', badge: 'The Analyst', badgeColor: 'bg-[#43A047]', text: 'Accurate and insightful. Highly recommended.', img: testimonial2, color: 'bg-green-100' },
  { name: 'Emily Rodriguez', role: 'Creative Director', badge: 'The Innovator', badgeColor: 'bg-[#8E24AA]', text: 'Loved the colorful results and easy-to-understand report.', img: testimonial3, color: 'bg-purple-100' },
];

const faqs = [
  { q: 'Are the tests really free?', a: ' Yes. You can take any test at no cost and see a summary of your results immediately.' },
  { q: 'Do I need an account to begin?', a: 'No. You can start and view your first results without an account.' },
  { q: 'How long do the tests take?', a: 'Most users finish in 6–10 minutes depending on the assessment.' },
  { q: 'Will I get full reports?', a: 'Yes. You receive a detailed report after each test you complete.' },
];

const Home = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col h-screen w-full overflow-x-hidden"
      data-home
      style={{
        position: 'relative',
        background: 'linear-gradient(180deg, #F1EFF5 0%, #E9EAF8 33%, #E8EAFF 66%, #F7EFF7 100%)',
      }}
    >
      <Navbar />

      <div
        className=" flex flex-col lg:flex-row w-full justify-center items-center h-full min-h-[900px] sm:min-h-[1000px] home-hero-wrap overflow-visible pt-48 sm:pt-60 md:pt-0 pb-24 sm:pb-28"
        style={{
          backgroundImage: `url(${wire})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center top',
          backgroundSize: 'cover'
        }}
      >
        {/* Two people image under navbar, positioned on the left (responsive) */}
        <img
          src={twoPeople}
          alt="two people"
          className=" top-[0px] sm:top-[0px] md:top-[0px] w-[280px] sm:w-[480px]  lg:w-[680px] object-contain z-0 md:z-10 max-w-[90vw]"
        />
      
        {/* Blue hearts decorative image (responsive) */}
        {/* Right side hero content */}
        <div className=" w-full max-w-[90vw] sm:max-w-[600px] z-20 home-hero px-2 sm:px-0 mx-auto"
        >
          <div className="flex flex-col items-center  ">
            <div className="mb-4 force-fluid w-full max-w-[467px]" style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                src={sparklesStars}
                alt="sparkles"
                className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] md:w-[60px] md:h-[60px]"
                style={{ transform: 'rotate(0deg)', opacity: 1 }}
              />
            </div>
            <h1 className="text-center md:text-left force-fluid w-full max-w-[520px]" style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600, fontStyle: 'italic', fontSize: 'clamp(28px, 7vw, 68px)', lineHeight: '120%', color: '#7A81FF' }}>
              <span className="force-fluid block" style={{ transform: 'rotate(0deg)', opacity: 1 }}>The Hard Work</span>
              <span className="block text-center" style={{ fontStyle: 'italic', color: '#000000' }}>Is</span>
              <span className="force-fluid block" style={{ transform: 'rotate(0deg)', opacity: 1 }}>The Heart Work</span>
            </h1>
            <p className="mt-4 mx-auto force-fluid w-full max-w-[520px] px-4 sm:px-0" style={{ transform: 'rotate(0deg)', opacity: 1, fontFamily: 'Lato, sans-serif', fontWeight: 400, fontStyle: 'normal', fontSize: 'clamp(16px, 4vw, 20px)', lineHeight: '140%', letterSpacing: '0%', textAlign: 'center', color: '#000000', whiteSpace: 'pre-line' }}>
              {`A new kind of self-discovery platform that helps you\nunderstand who you are beneath the surface and move\nforward with intention.`}
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-4 w-full max-w-[640px] justify-center px-4 sm:px-0 z-20">
              <button
                className="transition w-full sm:w-[292px]"
                style={{
                  height: '54px',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  gap: '10px',
                  borderRadius: '8px',
                  borderWidth: '1px',
                  paddingTop: '16px',
                  paddingRight: '32px',
                  paddingBottom: '16px',
                  paddingLeft: '32px',
                  background: '#B87AFF1A',
                  border: '1px solid #B74EF0',
                  fontFamily: 'Lato, sans-serif',
                  fontWeight: 700,
                  fontStyle: 'normal',
                  fontSize: 'clamp(14px, 3vw, 18px)',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  color: '#A726ED',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  whiteSpace: 'nowrap',
                  textAlign: 'center'
                }}
                onClick={() => navigate('')}
              >
                See the Heartwork Compass
              </button>
              <button
                className="transition w-full sm:w-[295px]"
                style={{
                  height: '54px',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  gap: '10px',
                  borderRadius: '8px',
                  paddingTop: '16px',
                  paddingRight: '32px',
                  paddingBottom: '16px',
                  paddingLeft: '32px',
                  background: '#7A81FF',
                  color: '#FFFFFF',
                  fontFamily: 'Lato, sans-serif',
                  fontWeight: 700,
                  fontStyle: 'normal',
                  fontSize: 'clamp(14px, 3vw, 18px)',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  whiteSpace: 'nowrap',
                  textAlign: 'center'
                }}
                onClick={() => window.open('https://3pbook.hwork2.com/')}
              >
                <span style={{
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  fontFamily: 'Lato, sans-serif',
                  fontWeight: 700,
                  fontStyle: 'normal',
                  fontSize: 'clamp(14px, 3vw, 18px)',
                  letterSpacing: '3%'
                }}>Start Free with Essence Echo</span>
              </button>
            </div>
            <div
              className="mt-4 text-center force-fluid w-full max-w-[640px] px-4 sm:px-0 z-20"
              style={{
                transform: 'rotate(0deg)',
                opacity: 1,
                fontFamily: 'Lato, sans-serif',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: 'clamp(13px, 3.3vw, 16px)',
                lineHeight: '130%',
                letterSpacing: '0%',
                color: '#A2A3A5'
              }}
            >
              No account needed to begin. Create a login after your first reflection.
            </div>
          </div>

        </div>
      </div>

      {/* Gradient info strip below hero */}
      <div
        className="w-full flex justify-center mb-8 px-4"
        style={{
          width: '100%',
          paddingTop: '24px',
          paddingRight: '10px',
          paddingBottom: '24px',
          paddingLeft: '10px',
          gap: '10px',
          background: 'linear-gradient(90deg, #B766CC 0%, #F38899 100%)',
          opacity: 1
        }}
      >
        <div
          className="flex flex-wrap items-center justify-center text-white text-sm font-semibold home-badge-line gap-2 sm:gap-4"
          style={{ maxWidth: '733px', minHeight: '22px' }}
        >
          <span className="whitespace-nowrap">Free to start</span>
          <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: '#7A81FF' }}></span>
          <span className="whitespace-nowrap">6–10 minutes</span>
          <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: '#7A81FF' }}></span>
          <span className="whitespace-nowrap">Built for reflection, not labels</span>
          <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: '#7A81FF' }}></span>
          <span className="whitespace-nowrap">Trusted by thousands</span>
        </div>
      </div>

      {/* Left text + right heart illustration section */}
      <section className="px-4 sm:px-6 lg:px-8 py-10">
        <div className="w-full max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* Left content */}
          <div className="flex flex-col items-start">
            <img src={lovely1} alt="heart" style={{ width: '34px', height: '34px', opacity: 1 }} />
            <h3 className="mt-6 force-fluid" style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600, fontSize: '42px', lineHeight: '100%', letterSpacing: '0%', color: '#1A1A1A', width: '500px', height: '112px', opacity: 1 }}>
              What Makes The HWork2
              <br />
              Method Different?
            </h3>
            <p className="mt-6 text-gray-800" style={{ fontFamily: 'Lato, sans-serif', fontSize: '18px', lineHeight: '150%' }}>
              HWork2 is an <span style={{ background: 'linear-gradient(180deg, #BA68CA 0%, #F28899 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>intentional space</span> for reflection and
              discovery. Our method blends psychology and guided
              insight to help you explore your patterns, strengths, and
              motivations in a way that <span style={{ background: 'linear-gradient(180deg, #BA68CA 0%, #F28899 100%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>feels personal; not clinical.</span>
            </p>
            <p className="mt-4 text-gray-800" style={{ fontFamily: 'Lato, sans-serif', fontSize: '18px', lineHeight: '150%' }}>
              This isn’t about being typed or labeled. It’s about seeing
              yourself clearly and using that awareness in your life, work
              and creativity.
            </p>
          </div>

          {/* Right image */}
          <div className="flex justify-center lg:justify-end">
            <img src={heartLogo} alt="heart illustration" className="w-full max-w-[529px] h-auto" style={{ opacity: 1 }} />
          </div>
        </div>
      </section>

    
      {/* Centered content section (The Heartwork Compass) */}
      <section className="px-4 sm:px-6 lg:px-8 pt-8 pb-4">
        <div className="w-full max-w-5xl mx-auto text-center">
          <div className="mx-auto bg-white shadow home-center-card w-full max-w-[622px]" style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '168px', paddingTop: '24px', paddingRight: '24px', paddingBottom: '24px', paddingLeft: '24px', gap: '16px', borderRadius: '24px', opacity: 1, overflow: 'visible' }}>
            <div className="flex items-center justify-center flex-wrap gap-2 sm:gap-3" style={{ overflow: 'visible' }}>
              <img src={routingIcon} alt="routing" className="w-6 h-6 sm:w-8 sm:h-8 flex-shrink-0" style={{ opacity: 1, display: 'block' }} />
              <h3 className="m-0 force-fluid text-center" style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600, fontSize: 'clamp(24px, 6vw, 42px)', lineHeight: '100%', letterSpacing: '0%', color: '#000000', opacity: 1 }}>
                The Heartwork Compass
              </h3>
            </div>
            <p className="mt-1 m-0 px-2" style={{ color: '#000000', fontFamily: 'Lato, sans-serif', fontSize: 'clamp(16px, 4vw, 20px)', lineHeight: '140%', letterSpacing: '0%' }}>
              A guided sequence of twelve assessments designed to build
              
              awareness, clarity, and action — one step at a time.
            </p>
          </div>
          <p className="mt-4 text-black mx-auto force-fluid px-4" style={{ maxWidth: '860px', fontFamily: 'Lato, sans-serif', fontSize: 'clamp(14px, 3vw, 16px)', lineHeight: '150%' }}>
            The order of these tests is intentional. Each layer prepares you for the next, moving from inner reflection to external activation. You are welcome to take any test
            individually, but the full Heartwork Compass was built to unfold in order — revealing how every part of you connects to the whole.
          </p>
        </div>
      </section>

      {/* Map image section */}
      <section className="px-4 sm:px-6 lg:px-8 pt-6 pb-6">
        <div className="w-full max-w-7xl mx-auto flex justify-center overflow-hidden">
          <img className="home-map w-full max-w-[1204px] h-auto" src={mapImage} alt="map" style={{ opacity: 1 }} />
        </div>
        <p className="mt-3 text-center px-4" style={{ fontFamily: 'Lato, sans-serif', fontWeight: 400, fontStyle: 'normal', fontSize: 'clamp(10px, 2vw, 12px)', lineHeight: '100%', letterSpacing: '0%', color: '#7A81FF' }}>
          The Compass connects disciplines that most platforms separate such as your strengths, personality, purpose, and <br className="hidden sm:block" /> emotion. Now, your insights build on one another instead of existing in pieces.
        </p>
      </section>

      {/* Six-step flow section */}
      <section className="px-4 sm:px-6 lg:px-8 pt-4 pb-10">
        <div className="w-full max-w-7xl mx-auto">
          <div
            className="mx-auto home-flow w-full max-w-[1277px]"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              background: 'linear-gradient(90deg, rgba(233, 234, 249, 0.5) 0%, rgba(242, 237, 249, 0.5) 100%)',
              borderRadius: '48px',
              padding: 'clamp(16px, 4vw, 32px)',
              gap: 'clamp(24px, 6vw, 48px)',
              boxShadow: '0px 2px 7px 0px #00000012',
              minHeight: '301px',
              opacity: 1
            }}
          >
            {/* Top row: numbers with arrows (shown on large screens) */}
            <div className="hidden lg:flex items-center justify-between px-4 mb-4">
              {['01','02','03','04','05','06'].map((num, idx) => (
                <div key={num} className="flex items-center">
                  <div
                    className="flex items-center justify-center rounded-full"
                    style={
                      idx === 0
                        ? { width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(142.57deg, rgba(200, 137, 212, 0.1) 4.6%, rgba(192, 127, 206, 0.1) 95.4%)', boxShadow: '0px 2px 7px 0px #00000012' }
                        : idx === 1
                          ? { width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(141.59deg, rgba(154, 207, 156, 0.1) 4.07%, rgba(129, 191, 131, 0.1) 95.93%)', boxShadow: '0px 2px 7px 0px #00000012', border: '1px solid rgba(255,255,255,0.6)' }
                          : idx === 2
                            ? { width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(139.65deg, rgba(138, 197, 245, 0.1) 2.88%, rgba(114, 179, 232, 0.1) 97.12%)', boxShadow: '0px 2px 7px 0px #00000012' }
                            : idx === 3
                              ? { width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(137.22deg, rgba(243, 191, 187, 0.1) 1.15%, rgba(236, 173, 168, 0.1) 98.85%)', boxShadow: '0px 2px 7px 0px #00000012' }
                              : idx === 4
                                ? { width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(140.01deg, rgba(241, 226, 106, 0.1) 3.12%, rgba(226, 211, 84, 0.1) 96.88%)', boxShadow: '0px 2px 7px 0px #00000012' }
                              : idx === 5
                                ? { width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(147.68deg, rgba(100, 129, 242, 0.1) 6.76%, rgba(73, 104, 225, 0.1) 93.24%)', boxShadow: '0px 2px 7px 0px #00000012' }
                            : { width: '48px', height: '48px', background: 'rgba(122,129,255,0.12)' }
                    }
                  >
                    <span style={
                      idx === 0
                        ? { fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#C136DB', width: '28px', height: '29px' }
                        : idx === 1
                          ? { fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#37C23C' }
                          : idx === 2
                            ? { fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#489CDF' }
                            : idx === 3
                              ? { fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#E8675B' }
                          : idx === 4
                            ? { fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#EFD500' }
                          : idx === 5
                            ? { fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#4B6AE3' }
                            : { color: '#7A81FF', fontFamily: 'Lato, sans-serif', fontWeight: 700 }
                    }>{num}</span>
                  </div>
                  {idx < 5 && (
                    <img src={ArrowImg} alt="arrow" className="ml-6 mr-2" style={{ width: '60px', height: '20px', opacity: 1 }} />
                  )}
                </div>
              ))}
            </div>

            {/* Steps grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6">
              <div>
                <div className="lg:hidden mb-2 flex items-center gap-2">
                  <div className="flex items-center justify-center rounded-full" style={{ width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(142.57deg, rgba(200, 137, 212, 0.1) 4.6%, rgba(192, 127, 206, 0.1) 95.4%)', boxShadow: '0px 2px 7px 0px #00000012' }}>
                    <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#C136DB', width: '28px', height: '29px' }}>01</span>
                  </div>
                </div>
                <div style={{ fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '115%', letterSpacing: '-2%', width: '168px', height: '56px', opacity: 1, background: 'linear-gradient(98.04deg, #BA68CA 10.08%, #F1879B 67.41%)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>
                  Start with
                  <br />
                  Reflection
                </div>
                <div className="mt-2" style={{ color: '#7D7F88', fontFamily: 'Lato, sans-serif', fontSize: '12px', lineHeight: '140%' }}>
                  Define your values and what
                  drives you.
                </div>
              </div>

              <div>
                <div className="lg:hidden mb-2 flex items-center gap-2">
                  <div className="flex items-center justify-center rounded-full" style={{ width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(141.59deg, rgba(154, 207, 156, 0.1) 4.07%, rgba(129, 191, 131, 0.1) 95.93%)', boxShadow: '0px 2px 7px 0px #00000012', border: '1px solid rgba(255,255,255,0.6)', opacity: 1 }}>
                    <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#37C23C' }}>02</span>
                  </div>
                </div>
                <div style={{ fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: '24px', lineHeight: '115%', letterSpacing: '-2%', width: '168px', height: '56px', opacity: 1, color: '#303044' }}>Discover
                  <br />
                  Strengths
                </div>
                <div className="mt-2" style={{ color: '#7D7F88', fontFamily: 'Lato, sans-serif', fontSize: '12px', lineHeight: '140%' }}>
                  Recognize what you
                  naturally do well.
                </div>
              </div>

              <div>
                <div className="lg:hidden mb-2 flex items-center gap-2">
                  <div className="flex items-center justify-center rounded-full" style={{ width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(139.65deg, rgba(138, 197, 245, 0.1) 2.88%, rgba(114, 179, 232, 0.1) 97.12%)', boxShadow: '0px 2px 7px 0px #00000012', position: 'relative' }}>
                    <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#489CDF', width: '28px', height: '29px', position: 'absolute', top: '20px', left: '20.67px', opacity: 1 }}>03</span>
                  </div>
                </div>
                <div style={{ fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: '24px', lineHeight: '115%', letterSpacing: '-2%', width: '168px', height: '56px', opacity: 1, color: '#303044' }}>Explore
                  <br />
                  Purpose
                </div>
                <div className="mt-2" style={{ color: '#7D7F88', fontFamily: 'Lato, sans-serif', fontSize: '12px', lineHeight: '140%' }}>
                  Find the link between what
                  you love and what matters.
                </div>
              </div>

              <div>
                <div className="lg:hidden mb-2 flex items-center gap-2">
                  <div className="flex items-center justify-center rounded-full" style={{ width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(137.22deg, rgba(243, 191, 187, 0.1) 1.15%, rgba(236, 173, 168, 0.1) 98.85%)', boxShadow: '0px 2px 7px 0px #00000012', position: 'relative' }}>
                    <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#E8675B', width: '28px', height: '29px', position: 'absolute', top: '20px', left: '21px', opacity: 1 }}>04</span>
                  </div>
                </div>
                <div style={{ fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: '24px', lineHeight: '115%', letterSpacing: '-2%', width: '168px', height: '56px', opacity: 1, color: '#303044' }}>See Your
                  <br />
                  Patterns
                </div>
                <div className="mt-2" style={{ color: '#7D7F88', fontFamily: 'Lato, sans-serif', fontSize: '12px', lineHeight: '140%' }}>
                  Understand habits, behavior,
                  and motivation.
                </div>
              </div>

              <div>
                <div className="lg:hidden mb-2 flex items-center gap-2">
                  <div className="flex items-center justify-center rounded-full" style={{ width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(140.01deg, rgba(241, 226, 106, 0.1) 3.12%, rgba(226, 211, 84, 0.1) 96.88%)', boxShadow: '0px 2px 7px 0px #00000012', position: 'relative' }}>
                    <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#EFD500', width: '28px', height: '29px', position: 'absolute', top: '20px', left: '20.33px', opacity: 1 }}>05</span>
                  </div>
                </div>
                <div style={{ fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: '24px', lineHeight: '115%', letterSpacing: '-2%', width: '168px', height: '56px', opacity: 1, color: '#303044' }}>Grow Through
                  <br />
                  Awareness
                </div>
                <div className="mt-2" style={{ color: '#7D7F88', fontFamily: 'Lato, sans-serif', fontSize: '12px', lineHeight: '140%' }}>
                  Explore emotion and how
                  you learn best.
                </div>
              </div>

              <div>
                <div className="lg:hidden mb-2 flex items-center gap-2">
                  <div className="flex items-center justify-center rounded-full" style={{ width: '69px', height: '70px', borderRadius: '50px', background: 'linear-gradient(147.68deg, rgba(100, 129, 242, 0.1) 6.76%, rgba(73, 104, 225, 0.1) 93.24%)', boxShadow: '0px 2px 7px 0px #00000012', position: 'relative' }}>
                    <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 700, fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#4B6AE3', width: '28px', height: '29px', position: 'absolute', top: '20px', left: '20.66px', opacity: 1 }}>06</span>
                  </div>
                </div>
                <div style={{ fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: '24px', lineHeight: '115%', letterSpacing: '-2%', width: '168px', height: '56px', opacity: 1, color: '#303044' }}>Integrate &
                  <br />
                  Move Forward
                </div>
                <div className="mt-2" style={{ color: '#7D7F88', fontFamily: 'Lato, sans-serif', fontSize: '12px', lineHeight: '140%' }}>
                  Revisit your Essence Echo
                  and see how you’ve evolved.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
        {/* CTA button below the six-step flow section */}
         <div className="w-full flex justify-center mb-8">
        <button
          className="transition"
          style={{
            width: '333px',
            height: '54px',
            opacity: 1,
            borderRadius: '8px',
            paddingTop: '16px',
            paddingRight: '32px',
            paddingBottom: '16px',
            paddingLeft: '32px',
            background: '#7A81FF',
            boxShadow: '4px 4px 14px 0px #00000040 inset, -4px -4px 14px 0px #FFFFFF40 inset',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <span style={{
            fontFamily: 'Lato, sans-serif',
            fontWeight: 700,
            fontSize: '18px',
            lineHeight: '100%',
            letterSpacing: '0%',
            color: '#FFFFFF',
            whiteSpace: 'nowrap'
          }}>Begin with Essence Echo</span>
        </button>
      </div>


      <section className="py-8 sm:py-12 lg:py-16 relative overflow-visible px-4 sm:px-6 lg:px-8">
        {/* Added: Heading and paragraph below the Begin with Essence Echo button */}
        <div className="w-full flex flex-col items-center justify-center mb-6">
          <div className="flex items-center justify-center flex-wrap px-4" style={{ gap: '12px' }}>
            <img src={hworkIcon} alt="hwork icon" style={{ width: '34px', height: '34px', transform: 'rotate(0deg)', opacity: 1 }} />
            <h3 className="m-0 force-fluid w-full text-center" style={{ transform: 'rotate(0deg)', opacity: 1, fontFamily: 'Playfair Display, serif', fontWeight: 600, fontStyle: 'normal', fontSize: 'clamp(24px, 6vw, 42px)', lineHeight: '120%', letterSpacing: '0%', color: '#000000' }}>
            Why HWork2 Works
            </h3>
          </div>
          <p className="mt-2 px-4 text-center" style={{ transform: 'rotate(0deg)', opacity: 1, fontFamily: 'Lato, sans-serif', fontWeight: 400, fontStyle: 'normal', fontSize: 'clamp(14px, 4vw, 20px)', lineHeight: '140%', letterSpacing: '0%', color: '#000000', maxWidth: '622px' }}>
          An insightful experience that's shorter, smarter, and more human.
          </p>
        </div>

        {/* Background photoroom image behind Why HWork2 Works boxes */}
        <img
          src={photoroom}
          alt="photoroom background"
          style={{
            position: 'absolute',
            width: '1564.8024885789282px',
            height: '1564.8024885789282px',
            transform: 'rotate(-11.98deg)',
            opacity: 1,
            top: '0px',
            left: '-224px',
            pointerEvents: 'none',
            zIndex: 0
          }}
        />

        {/* 5 Feature Boxes */}
        <div style={{ position: 'relative', zIndex: 1 }}>
        {/* Top row (3 cards) */}
        <div 
          className="w-full max-w-7xl mx-auto px-4 sm:px-6 mb-4 lg:px-8 home-feature-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 place-items-center"
        >
          {([
            {
              title: 'Twelve Tests. One Home.',
              desc: 'All major and original assessments in one connected experience.',
              frameBg: 'linear-gradient(112.43deg, rgba(255, 215, 215, 0.2) 10.38%, rgba(67, 62, 220, 0.2) 89.62%)',
              img: objectsImg,
              imgStyle: { width: '85%', maxHeight: '100%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            },
            {
              title: 'Shorter Tests. Deeper Questions.',
              desc: 'Fewer, more intentional prompts that make you think longer and reveal more.',
              frameBg: 'linear-gradient(112.76deg, rgba(234, 215, 255, 0.2) 10.72%, rgba(166, 91, 209, 0.2) 89.28%)',
              img: group1Img,
              imgStyle: { width: '85%', maxHeight: '90%', position: 'absolute', top: '55%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            },
            {
              title: 'More Human, Less Data.',
              desc: 'Reports that feel like mirrors, not measurements.',
              frameBg: 'linear-gradient(110.4deg, rgba(255, 163, 163, 0.2) 7.85%, rgba(255, 218, 218, 0.2) 92.15%)',
              img: moreFlowersImg,
              imgStyle: { width: '90%', maxHeight: '100%', position: 'absolute', top: '55%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            },
            {
              title: 'Insight You Can Use.',
              desc: 'Each reflection ends with takeaways you can act on right away.',
              frameBg: 'linear-gradient(110.32deg, rgba(141, 167, 237, 0.2) 7.74%, rgba(185, 214, 232, 0.2) 92.26%)',
              img: insightImg,
              imgStyle: { width: '80%', maxHeight: '100%', position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            },
            {
              title: 'Private and Yours.',
              desc: 'A clean, secure dashboard for full reports and lifetime access.',
              frameBg: 'linear-gradient(109.78deg, rgba(176, 162, 255, 0.2) 6.94%, rgba(55, 69, 201, 0.2) 93.06%)',
              img: privateImg,
              imgStyle: { width: '80%', maxHeight: '100%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            }
          ].slice(0,3)).map((feature, index) => (
            <div
              key={index}
              className="home-feature-card w-full max-w-[411px] mx-auto"
              style={{
                height: '386px',
                borderRadius: '12px',
                transform: 'rotate(0deg)',
                opacity: 1,
                background: '#FFFFFF99',
                boxShadow: '0px 2px 7px 0px #00000012',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
              }}
            >
              {/* Frame Section */}
              <div
                className="home-feature-frame w-full"
                style={{
                  height: '222px',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  background: feature.frameBg,
                  boxShadow: '0px 2px 7px 0px #00000012',
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '48px',
                  overflow: 'visible'
                }}
              >
                <img src={feature.img} alt={feature.title} style={feature.imgStyle} />
              </div>
              
              {/* Content Section */}
              <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', background: '#FFFFFF', borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                <h4 style={{
                  fontFamily: 'Playfair Display, serif',
                  fontWeight: 600,
                  fontSize: 'clamp(16px, 4vw, 18px)',
                  lineHeight: '120%',
                  color: '#000000',
                  margin: '0 0 12px 0',
                  textAlign: 'center'
                }}>
                  {feature.title}
                </h4>
                <p style={{
                  fontFamily: 'Lato, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 2.5vw, 12px)',
                  lineHeight: '140%',
                  color: '#9E9FA0',
                  margin: 0,
                  textAlign: 'center'
                }}>
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom row (2 centered cards) */}
        <div 
          className="w-full max-w-7xl mx-auto px-4 sm:px-6 mb-4 lg:px-8 home-feature-grid grid grid-cols-1 md:grid-cols-2 gap-6 place-items-center"
          style={{
            marginTop: '24px'
          }}
        >
          {([
            {
              title: 'Twelve Tests. One Home.',
              desc: 'All major and original assessments in one connected experience.',
              frameBg: 'linear-gradient(112.43deg, rgba(255, 215, 215, 0.2) 10.38%, rgba(67, 62, 220, 0.2) 89.62%)',
              img: objectsImg,
              imgStyle: { width: '85%', maxHeight: '88%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            },
            {
              title: 'Shorter Tests. Deeper Questions.',
              desc: 'Fewer, more intentional prompts that make you think longer and reveal more.',
              frameBg: 'linear-gradient(112.76deg, rgba(234, 215, 255, 0.2) 10.72%, rgba(166, 91, 209, 0.2) 89.28%)',
              img: group1Img,
              imgStyle: { width: '85%', maxHeight: '88%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            },
            {
              title: 'More Human, Less Data.',
              desc: 'Reports that feel like mirrors, not measurements.',
              frameBg: 'linear-gradient(110.4deg, rgba(255, 163, 163, 0.2) 7.85%, rgba(255, 218, 218, 0.2) 92.15%)',
              img: moreFlowersImg,
              imgStyle: { width: '90%', maxHeight: '88%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            },
            {
              title: 'Insight You Can Use.',
              desc: 'Each reflection ends with takeaways you can act on right away.',
              frameBg: 'linear-gradient(110.32deg, rgba(141, 167, 237, 0.2) 7.74%, rgba(185, 214, 232, 0.2) 92.26%)',
              img: insightImg,
              imgStyle: { width: '80%', maxHeight: '100%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            },
            {
              title: 'Private and Yours.',
              desc: 'A clean, secure dashboard for full reports and lifetime access.',
              frameBg: 'linear-gradient(109.78deg, rgba(176, 162, 255, 0.2) 6.94%, rgba(55, 69, 201, 0.2) 93.06%)',
              img: privateImg,
              imgStyle: { width: '80%', maxHeight: '100%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'contain' }
            }
          ].slice(3)).map((feature, index) => (
            <div
              key={`bottom-${index}`}
              className="home-feature-card w-full max-w-[411px] mx-auto"
              style={{
                height: '386px',
                borderRadius: '12px',
                transform: 'rotate(0deg)',
                opacity: 1,
                background: '#FFFFFF99',
                boxShadow: '0px 2px 7px 0px #00000012',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
              }}
            >
              <div
                className="home-feature-frame w-full"
                style={{
                  height: '222px',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  background: feature.frameBg,
                  boxShadow: '0px 2px 7px 0px #00000012',
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '48px',
                  overflow: 'visible'
                }}
              >
                <img src={feature.img} alt={feature.title} style={feature.imgStyle} />
              </div>
              <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', background: '#FFFFFF', borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                <h4 style={{
                  fontFamily: 'Playfair Display, serif',
                  fontWeight: 600,
                  fontSize: 'clamp(16px, 4vw, 18px)',
                  lineHeight: '120%',
                  color: '#000000',
                  margin: '0 0 12px 0',
                  textAlign: 'center'
                }}>
                  {feature.title}
                </h4>
                <p style={{
                  fontFamily: 'Lato, sans-serif',
                  fontWeight: 400,
                  fontSize: 'clamp(11px, 2.5vw, 12px)',
                  lineHeight: '140%',
                  color: '#9E9FA0',
                  margin: 0,
                  textAlign: 'center'
                }}>
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
        </div>
        <div className="w-full max-w-7xl mx-auto relative z-20">

        <div
            className="mx-auto mb-4"
            style={{
              width: '100vw',
              height: '80px',
              transform: 'rotate(0deg)',
              opacity: 1,
              paddingTop: '24px',
              paddingRight: '10px',
              paddingBottom: '24px',
              paddingLeft: '10px',
              background: '#FFFFFF99',
              marginLeft: 'calc(50% - 50vw)',
              marginRight: 'calc(50% - 50vw)'
            }}
          >
            <div className="w-full flex justify-center items-center">
              <span
                style={{
                  width: '807px',
                  height: '32px',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  fontFamily: 'Playfair Display, serif',
                  fontWeight: 500,
                  fontStyle: 'normal',
                  fontSize: '24px',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  background: 'linear-gradient(90deg, #B665CD 0%, #F28899 100%)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  color: 'transparent'
                }}
              >
                Other sites test to categorize you. HWork2 helps you connect with yourself.
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center mb-2" style={{ gap: '12px' }}>
            <img src={ratingIcon} alt="ranking" style={{ width: '34px', height: '34px', transform: 'rotate(0deg)', opacity: 1 }} />
            <h2
              className="m-0 text-center force-fluid px-4"
              style={{
                transform: 'rotate(0deg)',
                opacity: 1,
                fontFamily: 'Playfair Display, serif',
                fontWeight: 600,
                fontStyle: 'normal',
                fontSize: 'clamp(22px, 6vw, 42px)',
                lineHeight: '120%',
                letterSpacing: '0%'
              }}
            >
              Explore the 12 Ways to Understand Yourself
            </h2>
          </div>

          <p
            className="mb-6 sm:mb-8 px-4 text-center"
            style={{
              transform: 'rotate(0deg)',
              opacity: 1,
              fontFamily: 'Lato, sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: 'clamp(14px, 4vw, 20px)',
              lineHeight: '140%',
              letterSpacing: '0%',
              marginLeft: 'auto',
              marginRight: 'auto',
              color: ' #000000',
              maxWidth: '873px'
            }}
          >
            Each assessment offers a distinct lens into how you think, feel, and grow.
          </p>



          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 max-w-7xl mx-auto px-4 place-items-center">

            {tests.map((t, i) => {

              let customBg = undefined;

              if (t.color === 'bg-pink-100') customBg = 'rgba(255,182,179,0.5)';

              if (t.color === 'bg-purple-100') customBg = 'rgba(206,147,216,0.5)';

              if (t.color === 'bg-blue-100') customBg = 'rgba(144,202,249,0.5)';

              if (t.color === 'bg-yellow-100') customBg = 'rgba(255,204,128,0.5)';

              if (t.color === 'bg-green-100') customBg = 'rgba(165,214,167,0.5)';



              return (

                <div
                  key={i}
                  className="flex flex-col items-center text-center justify-center w-full max-w-[302px]"
                  style={{
                    width: '100%',
                    maxWidth: '302px',
                    height: '203px',
                    paddingTop: '32px',
                    paddingRight: '12px',
                    paddingBottom: '32px',
                    paddingLeft: '12px',
                    gap: '16px',
                    transform: 'rotate(0deg)',
                    opacity: 1,
                    borderRadius: '16px',
                    background: t.title === 'Johari Window Builder'
                      ? 'linear-gradient(119.03deg, rgba(250, 255, 253, 0.6) 5.63%, rgba(246, 255, 253, 0.6) 94.37%)'
                      : t.title === 'High 5 Strengths'
                      ? 'linear-gradient(123.12deg, rgba(251, 255, 251, 0.6) 9.02%, rgba(249, 255, 249, 0.6) 90.98%)'
                      : t.title === 'Character Strengths'
                      ? 'linear-gradient(116.56deg, rgba(245, 252, 255, 0.6) 2.8%, rgba(244, 251, 255, 0.6) 97.2%)'
                      : t.title === 'Big Five'
                      ? 'linear-gradient(119.03deg, rgba(250, 250, 255, 0.6) 5.63%, rgba(246, 246, 255, 0.6) 94.37%)'
                      : t.title === 'DISC Assessment'
                      ? 'linear-gradient(123.12deg, rgba(255, 251, 255, 0.6) 9.02%, rgba(255, 249, 254, 0.6) 90.98%)'
                      : t.title === 'Enneagram Finder'
                      ? 'linear-gradient(113.76deg, rgba(250, 255, 249, 0.6) 0.59%, rgba(247, 255, 246, 0.6) 99.41%)'
                      : t.title === 'TypeFusion Finder'
                      ? 'linear-gradient(116.56deg, rgba(255, 253, 246, 0.6) 2.8%, rgba(243, 253, 254, 0.6) 97.2%)'
                      : t.title === 'Emotional IQ'
                      ? 'linear-gradient(119.03deg, rgba(255, 250, 250, 0.6) 5.63%, rgba(255, 246, 246, 0.6) 94.37%)'
                      : t.title === 'Learning Style'
                      ? 'linear-gradient(123.12deg, rgba(255, 253, 251, 0.6) 9.02%, rgba(255, 253, 249, 0.6) 90.98%)'
                      : 'linear-gradient(116.56deg, rgba(255, 253, 246, 0.6) 2.8%, rgba(254, 251, 243, 0.6) 97.2%)',
                    boxShadow: '0px 2px 7px 0px #00000012'


                    
                  }}
                >

                  <div className="flex items-center w-[50px] h-[100px] justify-center mb-3"
                    style={{
                      borderRadius: '50%',
                      transform: 'rotate(0deg)',
                      opacity: 1,
                      background: t.title === 'Essence Echo'
                        ? 'linear-gradient(145.68deg, #CA8DD6 6.44%, #BE7ACC 93.56%)'
                        : t.title === 'IKIGAI Finder'
                        ? ' linear-gradient(145.68deg, #F7E873 6.44%, #DDCE4C 93.56%)'
                        : t.title === 'Johari Window Builder'
                        ? ' linear-gradient(145.68deg, #8CF5E9 6.44%, #5CCDC0 93.56%)'
                        : t.title === 'High 5 Strengths'
                        ? ' linear-gradient(145.68deg, #A0D3A2 6.44%, #77B979 93.56%)'
                        : t.title === 'Competencies Test'
                        ? ' linear-gradient(145.68deg, #F4B1AB 6.44%, #E3867E 93.56%)'
                        : t.title === 'Character Strengths'
                        ? ' linear-gradient(145.68deg, #8FC9F8 6.44%, #6CAEE5 93.56%)'
                        : t.title === 'Big Five'
                        ? ' linear-gradient(145.68deg, #6D89F8 6.44%, #4060DC 93.56%)'
                        : t.title === 'DISC Assessment'
                        ? ' linear-gradient(145.68deg, #DC88DC 6.44%, #CD69C4 93.56%)'
                        : t.title === 'Enneagram Finder'
                        ? ' linear-gradient(145.68deg, #A1DBA3 6.44%, #7ECB73 93.56%)'
                        : t.title === 'TypeFusion Finder'
                        ? ' linear-gradient(145.68deg, #8FDAF8 6.44%, #6CD7E5 93.56%)'
                        : t.title === 'Emotional IQ'
                        ? ' linear-gradient(145.68deg, #F8B1AA 6.44%, #E27171 93.56%)'
                        : t.title === 'Learning Style'
                        ? ' linear-gradient(145.68deg, #F7C973 6.44%, #DDA54C 93.56%)'
                        : 'linear-gradient(180deg, #8DEEDC 0%, #47CDBD 100%)',
                      
                    }}>

                    <img src={
                      t.title === 'Essence Echo'
                        ? spotifyLogo
                        : t.title === 'IKIGAI Finder'
                        ? flowerIcon
                        : t.title === 'High 5 Strengths'
                        ? puzzleIcon
                        : t.title === 'Johari Window Builder'
                        ? lovely
                        : t.title === 'Competencies Test'
                        ? competencyRanking
                        : t.title === 'Character Strengths'
                        ? sparklesStars
                        : t.title === 'Big Five'
                        ? bigfiveIcon
                        : t.title === 'DISC Assessment'
                        ? chartPie
                        : t.title === 'Enneagram Finder'
                        ? talentHand
                        : t.title === 'TypeFusion Finder'
                        ? operationIcon
                        : t.title === 'Emotional IQ'
                        ? healingIcon
                        : t.title === 'Learning Style'
                        ? graduationCap
                        : t.frame
                    } alt="frame" style={{ width: '24px', height: '24px', filter: t.title === 'Character Strengths' ? 'brightness(0) invert(1)' : undefined }} />
                  </div>

                  <div className="mb-2" style={{
                    fontFamily: 'Playfair Display, serif',
                    fontWeight: 600,
                    fontStyle: 'normal',
                    fontSize: '24px',
                    // fontSize: t.title === 'Johari Window Builder' ? '20px' : '24px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    // width: t.title === 'Johari Window Builder' ? '200px' : '148px',
                    height: '32px',
                    transform: 'rotate(0deg)',
                    opacity: 1,
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    alignSelf: 'center'
                  }}>{t.title}</div>

                  <div className="text-gray-600 text-xs sm:text-sm" style={{ color: '#9E9FA0', textAlign: 'center' }}>{t.desc}</div>

                </div>

              );

            })}

          </div>




        </div>

      </section>
      {/* Photoroom background image behind the 'Meet the Personality Test' content */}
      <img
        src={photoroom}
        alt="photoroom background"
        style={{
          position: 'absolute',
          width: '1564.8024885789282px',
          height: '1564.8024885789282px',
          transform: 'rotate(-11.98deg)',
          opacity: 1,
          top: '0px',
          left: '-224px',
          pointerEvents: 'none',
          zIndex: 0
        }}
      />



      {/* Testimonials Section */}

      <section className="py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8">

        <div className="w-full max-w-7xl mx-auto">

          <div className="w-full flex justify-center mb-4">
            <button
              className="transition"
              style={{
                width: '295px',
                height: '54px',
                gap: '10px',
                transform: 'rotate(0deg)',
                opacity: 1,
                borderRadius: '8px',
                paddingTop: '16px',
                paddingRight: '32px',
                paddingBottom: '16px',
                paddingLeft: '32px',
                background: '#7A81FF',
                boxShadow: '4px 4px 14px 0px #00000040 inset, -4px -4px 14px 0px #FFFFFF40 inset'
              }}
            >
              <span style={{
                width: '231px',
                height: '22px',
                transform: 'rotate(0deg)',
                opacity: 1,
                fontFamily: 'Lato, sans-serif',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '18px',
                lineHeight: '100%',
                letterSpacing: '0%',
                color: '#FFFFFF',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                textAlign: 'center'
              }}>
                Start Free with Essence Echo
              </span>
            </button>
                </div>

          <div className="flex flex-col items-center justify-center gap-3 mb-6 sm:mb-8">
            <img src={likeTag} alt="like tag" style={{ width: '34px', height: '34px', transform: 'rotate(0deg)', opacity: 1 }} />
            <h2 className="m-0 force-fluid text-center px-4" style={{ transform: 'rotate(0deg)', opacity: 1, fontFamily: 'Playfair Display, serif', fontWeight: 600, fontStyle: 'normal', fontSize: 'clamp(22px, 6vw, 42px)', lineHeight: '120%', letterSpacing: '0%' }}>
              What People Are Saying
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto place-items-center px-4">
            {[
              ['It didn’t give me a label. It', 'gave me language.'],
              ['I finally saw how my habits', 'and emotions connect.'],
              ['The reflections made me', 'think, not click.']
            ].map((lines, i) => (
              <div
                key={i}
                className="relative flex flex-col justify-center w-full max-w-[338px] mx-auto"
                style={{
                  height: '210px',
                  gap: '32px',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  borderRadius: '24px',
                  paddingTop: '48px',
                  paddingRight: '32px',
                  paddingBottom: '48px',
                  paddingLeft: '32px',
                  background: '#FFFFFF99',
                  boxShadow: '0px 2px 7px 0px #00000012'
                }}
              >
                <img src={quoteDown} alt="quote" style={{ position: 'absolute', top: '16px', left: '24px', width: '24px', height: '24px', transform: 'rotate(0deg)', opacity: 1 }} />
                <p style={{ width: '292px', height: '58px', transform: 'rotate(0deg)', opacity: 1, fontFamily: 'Lato, sans-serif', fontWeight: 400, fontStyle: 'italic', fontSize: '24px', lineHeight: '100%', letterSpacing: '0%', color: '#000000' }}>
                  “{lines[0]}<br />
                  {lines[1]}”
                </p>
                    </div>
            ))}
          </div>

        </div>

      </section>



      {/* Slim gradient stats strip after testimonials */}
      <div
        className="w-full"
        style={{
          width: '100vw',
          marginLeft: 'calc(50% - 50vw)',
          marginRight: 'calc(50% - 50vw)',
          background: 'linear-gradient(90deg, #B766CC 0%, #F38899 100%)',
          minHeight: '70px',
          opacity: 1
        }}
      >
        <div className="max-w-7xl mx-auto px-4 py-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="flex items-center justify-center text-white mx-auto flex-wrap sm:flex-nowrap" style={{ maxWidth: '733px', minHeight: '22px', gap: '10px', fontFamily: 'Lato, sans-serif', fontWeight: 600, fontStyle: 'normal', lineHeight: '100%', letterSpacing: '0%' }}>
            <span className="whitespace-nowrap text-[12px] sm:text-[16px]">10,000+ tests completed</span>
            <span className="w-2 h-2 rounded-full" style={{ background: '#7A81FF' }}></span>
            <span className="whitespace-nowrap text-[12px] sm:text-[16px]">92% say insights felt personal</span>
            <span className="w-2 h-2 rounded-full" style={{ background: '#7A81FF' }}></span>
            <span className="whitespace-nowrap text-[12px] sm:text-[16px]">Average time: under 10 minutes</span>
          </div>
        </div>
      </div>

      {/* FAQs Section */}

      <section className="py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8" style={{ position: 'relative' }}>

        {/* Background image behind Questions Before You Start */}
        <img
          src={require('../assets/question-before.png')}
          alt="questions background"
          style={{
            position: 'absolute',
            width: '1564.8024885789282px',
            height: '1564.8024885789282px',
            transform: 'rotate(-11.98deg)',
            opacity: 1,
            top: '-300px',
            left: '-224px',
            pointerEvents: 'none',
            zIndex: 0
          }}
        />

        <div className="w-full max-w-7xl mx-auto">

          <div className="flex flex-col items-center justify-center mb-2 px-4" style={{ gap: '12px' }}>
            <img src={messageQuestionIcon} alt="message question" style={{ width: '34px', height: '34px', transform: 'rotate(0deg)', opacity: 1 }} />
            <h2 className="m-0 force-fluid text-center" style={{ fontFamily: 'Playfair Display, serif', fontWeight: 600, fontStyle: 'normal', fontSize: 'clamp(22px, 6vw, 42px)', lineHeight: '120%', letterSpacing: '0%', transform: 'rotate(0deg)', opacity: 1 }}>
              Questions Before You Start?
            </h2>
          </div>

          <p className="mb-4 sm:mb-6 px-4 text-center" style={{ transform: 'rotate(0deg)', opacity: 1, fontFamily: 'Lato, sans-serif', fontWeight: 400, fontStyle: 'normal', fontSize: 'clamp(14px, 4vw, 20px)', lineHeight: '140%', letterSpacing: '0%', color: '#000000', marginLeft: 'auto', marginRight: 'auto', maxWidth: '622px' }}>
            Quick answers before you begin.
          </p>



          <div className="max-w-4xl mx-auto">

            <div className="grid grid-cols-[auto_1fr] items-center gap-2 mb-4 text-left">





            </div>



            <div className="space-y-3">

              {faqs.map((faq, i) => (

                <div key={i} className="flex flex-col">

                  <button

                    className="w-full flex flex-col text-left focus:outline-none font-medium text-gray-800 text-sm sm:text-base home-faq-item"

                    onClick={() => setOpenFaq(openFaq === i ? null : i)}

                    style={
                      faq.q === 'Are the tests really free?'
                        ? {
                            width: '1062px',
                            minHeight: '81px',
                            gap: '12px',
                            transform: 'rotate(0deg)',
                            opacity: 1,
                            borderRadius: '12px',
                            paddingTop: '24px',
                            paddingRight: '32px',
                            paddingBottom: '24px',
                            paddingLeft: '32px',
                            background: 'linear-gradient(90.88deg, #F9F4F9 0.04%, #EFF0FC 99.96%)',
                            boxShadow: '0px 2px 7px 0px #00000012',
                            borderWidth: '1px',
                            border: '1px solid #ECE5FF'
                          }
                        : {
                            width: '1062px',
                            minHeight: '81px',
                            gap: '12px',
                            transform: 'rotate(0deg)',
                            opacity: 1,
                            borderRadius: '12px',
                            paddingTop: '24px',
                            paddingRight: '32px',
                            paddingBottom: '24px',
                            paddingLeft: '32px',
                            background: '#FFFFFF99',
                            boxShadow: '0px 2px 7px 0px #00000012'
                          }
                    }

                  >

                    <div className="w-full flex justify-between items-center">
                    <span className="pr-4">{faq.q}</span>
                    <span className="ml-2 flex items-center justify-center flex-shrink-0">
                        <div style={{ width: '30px', height: '12px', transform: 'rotate(0deg)', opacity: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px' }}>
                      <img
                        src={downArrowFrame}
                        alt="toggle"
                            className={`transition-transform duration-200 ${openFaq === i ? 'rotate-180' : ''}`}
                            style={{ width: '20px', height: '20px' }}
                      />
                        </div>
                    </span>
                    </div>

                  {openFaq === i && (
                      <>
                        <div
                          style={{
                            width: '998px',
                            height: '0px',
                            transform: 'rotate(0deg)',
                            opacity: 0.5,
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderImageSource: 'linear-gradient(90deg, #7A81FF 0%, rgba(122, 129, 255, 0.1) 100%)',
                            borderImageSlice: 1,
                            margin: '8px 0'
                          }}
                        />
                        <div className="text-gray-600 text-xs sm:text-sm" style={{ paddingTop: '4px' }}>{faq.a}</div>
                      </>
                    )}

                  </button>

                </div>

              ))}

            </div>



            <div className="flex justify-center mt-6 sm:mt-8">

              <button
                className="transition text-white font-semibold"
                style={{
                  width: '164px',
                  height: '54px',
                  gap: '10px',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  borderRadius: '8px',
                  paddingTop: '16px',
                  paddingRight: '32px',
                  paddingBottom: '16px',
                  paddingLeft: '32px',
                  background: '#7A81FF',
                  boxShadow: '4px 4px 14px 0px #00000040 inset, -4px -4px 14px 0px #FFFFFF40 inset'
                }}
              >
                See all FAQs
              </button>

            </div>

          </div>

        </div>

      </section>



      {/* Call to Action Section */}

      <section className="flex flex-col items-center justify-center home-cta" style={{ background: 'linear-gradient(90deg, #B665CD 0%, #F48997 100%)', width: '100vw', maxWidth: '100vw', height: '448px', transform: 'rotate(0deg)', opacity: 1, paddingTop: '60px', paddingRight: '80px', paddingBottom: '60px', paddingLeft: '80px', gap: '60px' }}>

        <div className="w-full max-w-7xl mx-auto text-center">

          <div className="mx-auto mb-2" style={{ width: '57.50001525878906px', height: '60px', transform: 'rotate(0deg)', opacity: 1 }}>
            <img src={spotify} alt="spotify" style={{ width: '57.50001525878906px', height: '60px', transform: 'rotate(0deg)', opacity: 1, display: 'inline-block', filter: 'brightness(0) invert(1)' }} />
          </div>

          <h2
            className="text-white text-center mb-4 force-fluid"
            style={{
              width: '604px',
              height: '64px',
              transform: 'rotate(0deg)',
              opacity: 1,
              fontFamily: 'Playfair Display, serif',
              fontWeight: 600,
              fontStyle: 'normal',
              fontSize: '48px',
              lineHeight: '100%',
              letterSpacing: '0%',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            Every Journey Starts Within
          </h2>

          <p
            className="text-white mb-6 sm:mb-8 force-fluid"
            style={{
              width: '874px',
              height: '58px',
              transform: 'rotate(0deg)',
              opacity: 1,
              fontFamily: 'Lato, sans-serif',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '24px',
              lineHeight: '100%',
              letterSpacing: '0%',
              textAlign: 'center',
              
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            HWork2 was created for people ready to understand themselves in new ways. Start free today with Essence Echo and see how one reflection can shift everything.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full max-w-md sm:max-w-lg mx-auto">

            <button
              className="transition font-semibold"
              style={{
                width: '292px',
                height: '54px',
                gap: '10px',
                transform: 'rotate(0deg)',
                opacity: 1,
                borderRadius: '8px',
                paddingTop: '16px',
                paddingRight: '32px',
                paddingBottom: '16px',
                paddingLeft: '32px',
                borderWidth: '1px',
                border: '1px solid #B74EF0',
                background: '#EEE8F6',
                color: '#FFFFFF'
              }}
              // onClick={() => navigate('/login')}
            >
              <span style={{
                width: '228px',
                height: '22px',
                transform: 'rotate(0deg)',
                opacity: 1,
                fontFamily: 'Lato, sans-serif',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '18px',
                lineHeight: '100%',
                letterSpacing: '0%',
                color: '#A726ED',
                background: 'transparent',
                display: 'inline-block',
                textAlign: 'center',
                whiteSpace: 'nowrap'
              }}>
                See the Heartwork Compass
              </span>
            </button>

            <button
              className="transition"
              style={{
                width: '295px',
                height: '54px',
                gap: '10px',
                transform: 'rotate(0deg)',
                opacity: 1,
                borderRadius: '8px',
                paddingTop: '16px',
                paddingRight: '32px',
                paddingBottom: '16px',
                paddingLeft: '32px',
                background: '#7A81FF',
                boxShadow: '4px 4px 14px 0px #00000040 inset, -4px -4px 14px 0px #FFFFFF40 inset',
                border: 'none',
                color: '#FFFFFF'
              }}
            >
              <span
                style={{
                  width: '231px',
                  height: '22px',
                  transform: 'rotate(0deg)',
                  opacity: 1,
                  fontFamily: 'Lato, sans-serif',
                  fontWeight: 700,
                  fontStyle: 'normal',
                  fontSize: '18px',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  color: '#FFFFFF',
                  display: 'inline-block',
                  textAlign: 'center',
                  whiteSpace: 'nowrap'
                }}
              >
                Start Free with Essence Echo
              </span>
            </button>

          </div>

        </div>

      </section>



      {/* Footer Section */}

      <Footer />

    </div>

  );

};



export default Home;
